<template>
  <div>

    <el-dialog title="Dodaj wycielenie" :visible.sync="dialogVisible" :close-on-click-modal="false">

      <span class="my-label">Wybierz datę</span>
      <el-date-picker v-model="calvingDate" type="date" placeholder="Wybierz datę" style="width: 100%">
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Anuluj</el-button>
        <el-button type="primary" @click="addCalving(); dialogVisible = false" :disabled="calvingDate== null">Dodaj</el-button>
      </span>
    </el-dialog>

    <div class="my-btn-panel">
      <el-row :gutter="5">
        <el-col :span="10">
          <div class="grid-content ">

            <el-form>
              <el-form-item label="Aktualnie wybrana">

                <el-select v-model="cow" filterable placeholder="Wybierz krowę" v-on:change="onCowSelected" value-key="number">
                  <el-option v-for="item in cows" :key="item.number" :label="item.number" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>

          </div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content">
            <el-button type="success" class="my-btn" @click="showAddCalvedCowModal" :disabled="cow === null">Wycielenie jałówka</el-button>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content">
            <el-button type="success" class="my-btn" @click="dialogVisible = true" :disabled="cow === null">Wycielenie byk</el-button>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-button type="danger" class="my-btn" @click="deleteCalving" :disabled="currentRow === null">Usuń</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-table :data="calvingTableData" style="height: 65vh; overflow: auto;" height="auto" border stripe :default-sort="{prop: 'calving', order: 'descending'}"
      highlight-current-row @current-change="handleCurrentChange">
      <el-table-column label="Data wycielenia" prop="calving" sortable :formatter="formatter">
      </el-table-column>
      <el-table-column label="Zacielać" prop="toinsemination" :formatter="formatter">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import bus from "@/bus";

export default {
  props: ["herdSettings", "cows"],
  data: function() {
    return {
      calvingTableData: [],
      cow: null,
      currentRow: null,
      calvingDate: new Date(),
      dialogVisible: false
    };
  },
  mounted: function() {
    bus.$on(
      "cow-selected",
      function(value) {
        if (value) {
          this.cow = value;
          this.updateTable();
        }
      }.bind(this)
    );

    bus.$on(
      "add-calving",
      function(date) {
        this.calvingDate = date;
        this.addCalving();
      }.bind(this)
    );
  },
  methods: {
    formatter(row, column) {
      // console.log("row:", row, "column:", column.label, column.property)
      return row[column.property].toLocaleDateString(); //toISOString().slice(0, 10);
    },
    updateTable() {
      var tableData = [];
      if (this.cow != null && this.cow.calving != null) {
        this.cow.calving.forEach(
          function(entry) {
            //  console.log(entry, "-", this.herdSettings.repetition);
            var newEntry = new Date(entry);
            var toinsemination = new Date(entry);

            toinsemination.setDate(
              newEntry.getDate() + this.herdSettings.cai_time_interval
            );

            tableData.push({
              calving: newEntry,
              toinsemination: toinsemination
            });
          }.bind(this)
        );
      }
      this.calvingTableData = tableData;
    },
    handleCurrentChange(value) {
      this.currentRow = value;
    },
    onCowSelected() {
      if (this.cow != null) {
        bus.$emit("cow-selected", this.cow);
      }
    },
    showAddCalvedCowModal() {
      bus.$emit("showAddCalvedCowModal");
    },
    addCalving() {
      if (this.cow != null) {
        if (this.cow.calving == null) {
          this.cow.calving = [];
        }
        this.cow.with_calf = false;
        this.cow.calving.push(this.calvingDate.toJSON());
        this.updateTable();
        this.calvingDate = new Date();
        bus.$emit("save-cow", this.cow);
      }
    },
    deleteCalving() {
      if (this.currentRow !== null) {
        this.cow.calving = this.cow.calving.filter(
          function(item) {
            return (
              this.currentRow.calving.getTime() != new Date(item).getTime()
            );
          }.bind(this)
        );

        this.updateTable();

        bus.$emit("save-cow", this.cow);
      }
    }
  }
};
</script>

<style>

</style>
